import { useSelector } from "react-redux";
import { Badge, Group, Tooltip} from '@mantine/core';
import intl from "react-intl-universal";

export function DocSignCountOverview(props:any) {

  const initdocs =  useSelector((state: any) => state.user.meetingdocs) || [];
  

  // Anzahl der User die dieses Dokument unterschreiben sollen 
  const countdocs = initdocs?.filter((obj: { isToBeSigned: any; }) => {
       return obj.isToBeSigned === true;
   });

   const countdocssigned = initdocs.filter((obj: { isSignedByAll: any; }) => {
       return obj.isSignedByAll === true;
   });

const countdocsArray:any = Object.values(countdocs);
const countdocssignedArray:any = Object.values(countdocssigned);

  return (
    <>
    <Group>
    <Tooltip label={intl.get('SIGDOCCOUNT_ALL')} multiline={true}>
        <Badge color="gray" variant="outline">{countdocsArray.length}</Badge>
    </Tooltip>
    <Tooltip label={intl.get('SIGDOCCOUNT_ALL_DONE')} multiline={true}>
        <Badge color="green" variant="outline">{countdocssignedArray.length}</Badge>
        </Tooltip>
   </Group>
    </>
  );
}